import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ChangeLogList from "../../components/FeatureConfig/FeatureConfigDetail";
import * as FeatureConfigChangeLogActions from "../../store/actions/FeatureConfigDetails";
import ErrorMsgs from "../../constants/Errors.json";
import * as UserActions from "../../store/actions/User";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import { useLocation } from "react-router-dom";
import Permission from "../../components/Common/Permission";

const ConfigChangeLog = (props) => {
  const location = useLocation();
  const searchQueryParams = location.search;
  const params = new URLSearchParams(searchQueryParams);
  const configMetadata = {
    namespace: params.get("namespace"),
    key: params.get("key"),
    entity: params.get("entity"),
    entityId: params.get("entityId"),
  };

  const allActions = MenuActionsMappings[MenuNames.FEATURE_CONFIG];
  const [configVersions, setConfigVersions] = useState([]);

  const updateChangeLog = () => {
    props
      .getConfigChangeLog(configMetadata)
      .then((response) => {
        const sortedConfigVersions = (list) => {
          const newList = list.sort(function (a, b) {
            return parseInt(b.version, 10) - parseInt(a.version, 10);
          });
          return newList;
        };
        setConfigVersions(sortedConfigVersions(response?.configVersions ?? []));
      })
      .catch((err) => {
        props.setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        });
      });
  };

  useEffect(() => {
    updateChangeLog();
  }, []);

  return (
    <ChangeLogView>
      <Permission requiredPerms={[]}>
        <ChangeLogList
          configVersions={configVersions}
          updateChangeLog={updateChangeLog}
          configMetadata={configMetadata}
        />
      </Permission>
    </ChangeLogView>
  );
};

const mapStateToProps = (state) => {
  const { ConfigChangeLog, City } = state;
  return {
    CityPropertyChangeLog: ConfigChangeLog.CityPropertyChangeLog,
    GenSettingChangeLog: ConfigChangeLog.GenSettingChangeLog,
    nextPageCity: City.nextPage,
    Source: ConfigChangeLog.Source,
    nextPage: ConfigChangeLog.nextPage,
    prevPage: ConfigChangeLog.prevPage,
    activeFilters: ConfigChangeLog.activeChangeLogFilters,
    keysNextPage: ConfigChangeLog.keysNextPage,
    keysPrevPage: ConfigChangeLog.keysPrevPage,
    nextPageCity: City.nextPage,
  };
};

const ChangeLogView = styled.section`
  height: calc(100vh - 200px);
  .MuiAutocomplete-root {
    margin-bottom: unset !important;
  }
`;

const mapDispatchToProps = (dispatch) => {
  return {
    getConfigChangeLog: bindActionCreators(
      FeatureConfigChangeLogActions.getConfigChangeLog,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigChangeLog);
